import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { ApiService } from 'src/app/Services/api.service';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormArray } from '@angular/forms';
import { access } from 'fs';

@Component({
    selector: 'app-editcontrolledareaaccessmethod',
    templateUrl: './editcontrolledareaaccessmethod.component.html',
    styleUrls: ['./editcontrolledareaaccessmethod.component.scss'],
    standalone: false
})
export class EditcontrolledareaaccessmethodComponent extends SimpleModalComponent<any, any> implements OnInit {
  Form !: UntypedFormGroup;
  ParkingLots: any[] = [];
  selectedLot: any = null;
  selectedGate: any = null;

  public RateSets: any[] | null = null;
  public AccessLists: any[] | null = null;
  constructor(private apiService: ApiServiceBase) {
    super();
  }

  public NewMethod: boolean = true;

  ngOnInit(): void {
    // Initialize form controls with existing values if they exist
    const existingRateSetId = this.Form.get('RateSetId')?.value;
    const existingRateSetName = this.Form.get('RateSetName')?.value;
    const existingChargeStrategy = this.Form.get('ChargeStrategy')?.value;
    const existingHoldChargeAmount = this.Form.get('HoldChargeAmount')?.value;
    const existingTargetParkingLotId = this.Form.get('TargetParkingLotId')?.value;
    const existingTargetGateId = this.Form.get('TargetGateId')?.value;
    const existingTargetLaneId = this.Form.get('TargetLaneId')?.value;

    // Add or update form controls
    if (!this.Form.get('ChargeStrategy')) {
      this.Form.addControl('ChargeStrategy', new UntypedFormControl(existingChargeStrategy || 'None'));
    }
    if (!this.Form.get('HoldChargeAmount')) {
      this.Form.addControl('HoldChargeAmount', new UntypedFormControl(existingHoldChargeAmount));
    }
    if (!this.Form.get('TargetParkingLotId')) {
      this.Form.addControl('TargetParkingLotId', new UntypedFormControl(existingTargetParkingLotId));
    }
    if (!this.Form.get('TargetGateId')) {
      this.Form.addControl('TargetGateId', new UntypedFormControl(existingTargetGateId));
    }
    if (!this.Form.get('TargetLaneId')) {
      this.Form.addControl('TargetLaneId', new UntypedFormControl(existingTargetLaneId));
    }
    if (!this.Form.get('RateSetId')) {
      this.Form.addControl('RateSetId', new UntypedFormControl(existingRateSetId));
    }
    if (!this.Form.get('RateSetName')) {
      this.Form.addControl('RateSetName', new UntypedFormControl(existingRateSetName));
    }

    if(this.Form.get('Id')) {
      this.NewMethod = false;
    }
    
    this.apiService.Post<any>("parking/ratesets/searches", { PageNumber: 1, PageSize: 9999, Page: 1 })
      .then(result => {
        this.RateSets = result.Results;
        // If we have an existing rate set, ensure it's selected in the dropdown
        if (existingRateSetId && this.RateSets) {
          const existingSet = this.RateSets.find(x => x.Id === existingRateSetId);
          if (existingSet) {
            this.Form.get('RateSetName')?.setValue(existingSet.Name);
          }
        }
      });
    this.apiService.Post<any>("parking/plateaccess/searches", { PageNumber: 1, PageSize: 9999, Page: 1 })
      .then(result => {
        this.AccessLists = result.Results;
      });

    // If editing existing method, set up the selected values
    if (!this.NewMethod) {
      this.setupExistingSelection();
    }
  }

  private setupExistingSelection() {
    const lotId = this.Form.get('TargetParkingLotId')?.value;
    const gateId = this.Form.get('TargetGateId')?.value;
    
    if (lotId) {
      this.loadLotDetails(lotId).then(() => {
        if (gateId) {
          // Find the selected gate
          for (const level of this.selectedLot.Levels) {
            this.selectedGate = level.Gates.find((gate: { Id: string }) => gate.Id === gateId);
            if (this.selectedGate) break;
          }
        }
      });
    }
  }

  private async loadLotDetails(lotId: string): Promise<void> {
    try {
      const lotDetails = await this.apiService.Get<any>(`infrastructure/parkinglots/${lotId}`);
      this.selectedLot = lotDetails;
    } catch (error) {
      console.error('Error loading lot details:', error);
      this.selectedLot = null;
    }
  }

  async onLotChange() {
    const lotId = this.Form.get('TargetParkingLotId')?.value;
    this.selectedLot = null;
    this.selectedGate = null;
    
    // Reset dependent fields
    this.Form.get('TargetGateId')?.setValue(null);
    this.Form.get('TargetLaneId')?.setValue(null);

    if (lotId) {
      await this.loadLotDetails(lotId);
    }
  }

  onGateChange() {
    const gateId = this.Form.get('TargetGateId')?.value;
    this.selectedGate = null;
    
    if (this.selectedLot && gateId) {
      // Find the selected gate
      for (const level of this.selectedLot.Levels) {
        this.selectedGate = level.Gates.find((gate: { Id: string }) => gate.Id === gateId);
        if (this.selectedGate) break;
      }
    }
    
    // Reset dependent field
    this.Form.get('TargetLaneId')?.setValue(null);
  }

  public GetClassName(): any {
    return this.Form.get('ClassName')?.value;
  }

  public ClassChanged() {
    let name = this.GetClassName();    
    let accessMethodDesc = this.Form.get('AccessMethodDescription');
    if (name == 'ControlledAreaAccessMethodWhiteList') {
      let accessListName = this.Form.get('PlateAccessListName');
      if (accessListName == null) {
        this.Form.addControl('PlateAccessListName', new UntypedFormControl());
      }

      let accessListId = this.Form.get('PlateAccessListId');
      if (accessListId == null) {
        this.Form.addControl('PlateAccessListId', new UntypedFormControl());
      }
      accessMethodDesc?.setValue("Access List Only");
    }
    if (name == 'ControlledAreaAccessMethodPublic') {
      let accessListName = this.Form.get('PlateAccessListName');
      if (accessListName != null) {
        accessListName.setValue(null);
      }

      let accessListId = this.Form.get('PlateAccessListId');
      if (accessListId != null) {
        accessListId.setValue(null);
      }
      accessMethodDesc?.setValue("Public Access")
    }
  }

  public RateSetChanged() {
    const selectedId = this.Form.get('RateSetId')?.value;
    const selectedSet = this.RateSets?.find(x => x.Id === selectedId);
    
    if (selectedSet) {
      this.Form.get('RateSetName')?.setValue(selectedSet.Name);
    } else {
      this.Form.get('RateSetName')?.setValue(null);
    }
    
    this.UpdateChargeStrategyDescription();
  }

  public AccessListChanged() {
    let x = this.Form.get('PlateAccessListName');
    let id = this.Form.get('PlateAccessListId')?.value;
    let set = this.AccessLists?.filter(x => x.Id == id)[0];
    x?.setValue(set.Name);

    let accessMethodDesc = this.Form.get('AccessMethodDescription');
    accessMethodDesc?.setValue("Vehicles on " + set.Name);
  }

  public GetChargeStrategy(): string {
    return this.Form.get('ChargeStrategy')?.value;
  }

  public UpdateChargeStrategyDescription() {
    let id = this.Form.get('RateSetId')?.value;
    let set = this.RateSets?.filter(x => x.Id == id)[0];
    let csd = this.Form.get('ChargeStrategyDescription');
    let chargeAmt = this.Form.get('HoldChargeAmount');
    let ChargeStrategy = this.GetChargeStrategy();

    switch(ChargeStrategy) {
      case "None":
        csd?.setValue("No charges apply");
        break;
      case "Hold":
        csd?.setValue(`Holds ${chargeAmt?.value ?? 0} on entry, then charges ${set?.Name ?? "<not set>"} on exit`);
        break;
      case "PrePay":
        csd?.setValue(`Charges ${set?.Name} on entry`);
        break;
      case "PostPay":
        csd?.setValue(`Charges ${set?.Name} on exit`);
        break;
    }
  }

  public ShowRateSet(): boolean {
    const ChargeStrategy = this.GetChargeStrategy();
    return ChargeStrategy === 'PostPay' || ChargeStrategy === 'PrePay' || ChargeStrategy === 'Hold';
  }

  public ChargeStrategyChanged() {
    const ChargeStrategy = this.GetChargeStrategy();
    
    const HoldChargeAmountControl = this.Form.get('HoldChargeAmount');
    if (ChargeStrategy === 'Hold') {
      if (HoldChargeAmountControl) {
        HoldChargeAmountControl.setValidators([Validators.required, Validators.min(0)]);
      }
    } else {
      if (HoldChargeAmountControl) {
        HoldChargeAmountControl.clearValidators();
        HoldChargeAmountControl.setValue(null);
      }
    }
    
    const rateSetControl = this.Form.get('RateSetId');
    if (ChargeStrategy === 'None') {
      if (rateSetControl) {
        rateSetControl.clearValidators();
        rateSetControl.setValue(null);
      }
    } else {
      if (rateSetControl) {
        rateSetControl.setValidators([Validators.required]);
      }
    }

    if (HoldChargeAmountControl) HoldChargeAmountControl.updateValueAndValidity();
    if (rateSetControl) rateSetControl.updateValueAndValidity();
    this.UpdateChargeStrategyDescription();
  }

  // Target selection methods
  public selectLot(lotId: string) {
    this.Form.get('TargetParkingLotId')?.setValue(lotId);
    this.Form.get('TargetGateId')?.setValue(null);
    this.Form.get('TargetLaneId')?.setValue(null);
  }

  public selectGate(gateId: string) {
    this.Form.get('TargetGateId')?.setValue(gateId);
    this.Form.get('TargetLaneId')?.setValue(null);
  }

  public selectLane(laneId: string) {
    this.Form.get('TargetLaneId')?.setValue(laneId);
  }

  public clearSelection() {
    this.Form.get('TargetParkingLotId')?.setValue(null);
    this.Form.get('TargetGateId')?.setValue(null);
    this.Form.get('TargetLaneId')?.setValue(null);
  }

  public isSelected(type: string, id: string): boolean {
    switch(type) {
      case 'lot':
        return this.Form.get('TargetParkingLotId')?.value === id;
      case 'gate':
        return this.Form.get('TargetGateId')?.value === id;
      case 'lane':
        return this.Form.get('TargetLaneId')?.value === id;
      default:
        return false;
    }
  }

  public isDisabled(type: string, id: string): boolean {
    const selectedLotId = this.Form.get('TargetParkingLotId')?.value;
    const selectedGateId = this.Form.get('TargetGateId')?.value;

    switch(type) {
      case 'lot':
        return false; // Lots are never disabled
      case 'gate':
        return selectedLotId != null && selectedLotId !== id;
      case 'lane':
        return selectedGateId != null && selectedGateId !== id;
      default:
        return false;
    }
  }

  cancel() {
    this.result = false;
    this.close();
  }

  confirm() {
    this.result = true;
    this.close();
  }
}
